<obg-m-dialog-layout
	test-id="dialog-layout-modal"
	#dialog
	[titleText]="'account-details.annual-data-validation.update-details' | translate"
	[hideFooter]="false"
	[hideClose]="false"
	[navbar]="true"
	[navbarOptions]="navbarOptions"
	[ngStyle]="!shouldShow ? { 'display': 'none' } : null"
>
	<account-annual_data_validation_edit
		(customerUpdated)="handleCustomerUpdateOutcome($event.detail)"
		(discardChangesClick)="closeDialog()"
		(openFacialRecognition)="openFacialRecognition()"
		(openTwoFactorAuthentication)="openTwoFactorAuthentication($event.detail)"
		(closeTwoFactorAuthentication)="closeTwoFactorAuthentication()"
		(currentCustomer)="updateCustomer($event.detail)"
		[isLoading]="loadingSpinner"
	/>
</obg-m-dialog-layout>
